// @flow

import { observer } from "mobx-react";
import React from "react";

import Icon from "app/components/Icon/Icon";

import "./VolumeButton.scss";

type Props = {
    volume: number,
    onChange: Function
};

@observer
export default class VolumeButton extends React.Component<Props> {
    get icon(): string {
        const volume = parseInt(this.props.volume, 10);
        if (volume === 0) return 'volume-off';
        if (volume <= 50) return 'volume-down';

        return 'volume-up';
    }

    get title(): string {
        const volume = parseInt(this.props.volume, 10);
        if (volume === 0) return 'Unmute';

        return 'Mute';
    }

    handleChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
        this.props.onChange(event.target.value);
    };

    handleMuteClick = (event: SyntheticInputEvent<HTMLInputElement>) => {
        this.props.onChange(this.props.volume > 0 ? 0 : 100);
    };

    render() {
        return (
            <div className="VolumeButton">
                <div className="VolumeButton__container">
                    <button className="PlayButton" type="button" onClick={this.handleMuteClick} title={this.title}>
                        <Icon name={this.icon} fontAwesome={true}/>
                    </button>
                    
                    <input type="range" className="VolumeButton__input" min="0" max="100" step="1"
                           value={this.props.volume} onChange={this.handleChange}/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/app/components/VolumeButton/VolumeButton.js